import m from 'mithril'

export default m.trust(`
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 12C10 12.5304 9.78929 13.0391 9.41421 13.4142C9.03914 13.7893 8.53043 14 8 14C7.46957 14 6.96086 13.7893 6.58579 13.4142C6.21071 13.0391 6 12.5304 6 12" stroke="white" stroke-opacity="0.4"/>
<path d="M3.5 11.5V7C3.5 4.51472 5.51472 2.5 8 2.5C10.4853 2.5 12.5 4.51472 12.5 7V11.5M1.5 11.5H14.5" stroke="white" stroke-opacity="0.4"/>
</svg>
`)